import fetch from 'isomorphic-fetch';
import { push } from 'react-router-redux';
import { checkHttpStatus, parseJSON } from '../utils';
import {
  AUTH_LOGIN_USER_REQUEST,
  AUTH_LOGIN_USER_FAILURE,
  AUTH_LOGIN_USER_SUCCESS,
  AUTH_LOGIN_USER_MESSAGE,
  AUTH_LOGOUT_USER,
  AUTH_RECOVER_FAILURE,
  AUTH_RECOVER_REQUEST,
  AUTH_RECOVER_SUCCESS,
  AUTH_UPDATE_USER_SUCCESS,
} from '../constants';

import { host } from '../config';

export function authLoginUserSuccess(payload) {
  sessionStorage.setItem('auth', JSON.stringify(payload));
  return {
    type: AUTH_LOGIN_USER_SUCCESS,
    payload,
  };
}
export function authRecoverLoginSuccess(payload) {
  return {
    type: AUTH_RECOVER_SUCCESS,
    payload,
  };
}
export function authRecoverLoginFailure(payload) {
  return {
    type: AUTH_RECOVER_FAILURE,
    payload,
  };
}
export function authRecoverLoginRequest() {
  return {
    type: AUTH_RECOVER_REQUEST,
  };
}

export function authLoginUserFailure(error, message) {
  sessionStorage.removeItem('auth');
  return {
    type: AUTH_LOGIN_USER_FAILURE,
    payload: {
      status: error,
      statusText: message,
    },
  };
}
export function authLoginMessage(payload) {
  sessionStorage.removeItem('auth');
  return {
    type: AUTH_LOGIN_USER_MESSAGE,
    payload,
  };
}

export function authLoginUserRequest() {
  return {
    type: AUTH_LOGIN_USER_REQUEST,
  };
}

export function authLogout() {
  sessionStorage.removeItem('auth');
  sessionStorage.removeItem('prefs');
  return {
    type: AUTH_LOGOUT_USER,
  };
}

export function authUpdateUser(payload) {
  const auth = JSON.parse(sessionStorage.getItem('auth'));
  auth.profile = payload;
  sessionStorage.setItem('auth', JSON.stringify(auth));
  return {
    type: AUTH_UPDATE_USER_SUCCESS,
    payload,
  };
}

export function authLogoutAndRedirect() {
  return (dispatch, state) => {
    // eslint-disable-line no-unused-vars
    dispatch(authLogout());
    return dispatch(push('/login'));
  };
}

export function authLoginUser(email, password, is_terms_accepted, redirect = '/') {
  return dispatch => {
    dispatch(authLoginUserRequest());
    return fetch(`${host}/api/auth2/obtain_auth_token_with_profile/`, {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        username: email,
        password,
        is_terms_accepted
      }),
    })
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(authLoginUserSuccess(response));
        dispatch(push(redirect));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          if (error.response.status >= 500) {
            console.log(error);

            return dispatch(
              authLoginUserFailure(
                error.response.status,
                'Yikes. Problem with the server. Try again in a sec.'
              )
            );
          }
          return dispatch(
            authLoginUserFailure(
              'Unable to log in',
              'Sorry, you entered an incorrect email address or password.'
            )
          );
        }
        // Most likely connection issues or code error
        return dispatch(
          authLoginUserFailure('Connection Error', 'An error occurred while sending your data!')
        );
      });
  };
}

export function authWithToken(token, redirect = '/') {
  return dispatch => {
    dispatch(authLoginUserRequest());
    return fetch(`${host}/api/auth2/login/`, {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token,
      }),
    })
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(authLoginUserSuccess(response));
        dispatch(push(redirect));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          if (error.response.status >= 500) {
            dispatch(push(`/login?next=${redirect}`));
            return dispatch(
              authLoginUserFailure(
                'Login failed.',
                'Yikes. Problem with the server. Try again in a sec.'
              )
            );
          }
          return error.response.json().then(json => {
            console.log('Error logging in... expired link?', json.detail);
            dispatch(push(`/login?next=${redirect}`));
            return dispatch(authLoginUserFailure('Login failed.', json.detail));
          });
        }
        // Most likely connection issues or code error
        dispatch(push(`/login?next=${redirect}`));
        return dispatch(
          authLoginUserFailure('Connection Error', 'An error occurred while sending your data!')
        );
      });
  };
}
export function authRecoverLogin(email) {
  return dispatch => {
    dispatch(authRecoverLoginRequest());
    return fetch(`${host}/api/auth2/recover/`, {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
      }),
    })
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(authRecoverLoginSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          if (error.response.status >= 404) {
            console.log(error);
            return dispatch(authRecoverLoginFailure(''));
          }
          return error.response.json().then(detail => {
            return dispatch(authRecoverLoginFailure(detail));
          });
        }
        // Most likely connection issues or code error
        return dispatch(authRecoverLoginFailure(''));
      });
  };
}



// WEBPACK FOOTER //
// src/actions/auth.js